/* Component Dependencies */
var arrivalInformationTemplate = require('templates/arrivalInformation.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'arrivalInformation',
    template: {
        'arrivalInformation': arrivalInformationTemplate
    }
});